import React from 'react';
import { useTranslation } from 'react-i18next';
import helpers from "../../Utils/helpers";

function CustomerProducts ({ products,subscriptions }) {
    const { t } = useTranslation();

    function renderOnPremProducts(onPremProducts) {
        let key = 1;
        return onPremProducts && onPremProducts.length > 0 && <>
        <h3>{t('customerproducts.products')}</h3>
        {onPremProducts.map(item =>
            <div key={key++} className="pb-10">
                <div><strong>{item.product}</strong> ({item.purchaseDate} - {!item.isProductValid ? <span style={{ color: "red" }}>{item.endDate}</span> : item.endDate})</div>
                <div className="text-left">{t('customerproducts.users')}{item.users}</div>
                {item.api && <div className="text-left">{t('customerproducts.api')}{item.api}</div>}
            </div>)}
        </>
    }

    function renderSubscriptions(subscriptions) {
        let key = 1;

        return subscriptions && subscriptions.length > 0 && <>
            <h3>{t('vonproducts.header')}</h3>
                {subscriptions.map(item =>
                    <div key={key++} className="pb-10">
                        <div><strong>{item.tier.name}</strong> ({helpers.formatDate(item.subscriptionBillingPeriod.startDate)} - {item.termination ? <span style={{ color: "red" }}>{helpers.formatDate(item.termination.scheduledDate)}</span> : helpers.formatDate(item.subscriptionBillingPeriod.endDate)})</div>
                    </div>)}
        </>
    }

    return (
        <div>
            {renderOnPremProducts(products)}
            {renderSubscriptions(subscriptions)} 
        </div>
    )
}

export default CustomerProducts;